export * from "./src/paid-hero";
export { PaidHero as default } from "./src/paid-hero";
